// extracted by mini-css-extract-plugin
export default {"letterKeyboard":"LetterKeyboard_letterKeyboard__tytad","thirdRow":"LetterKeyboard_thirdRow__60FzG"};